import Logo from "../components/Logo";
import { NAV, CALENDLY } from "../data/site";

const SOCIALS = [
  { label: "INSTAGRAM", href: "https://instagram.com" },
  { label: "YOUTUBE", href: "https://youtube.com" },
  { label: "X", href: "https://x.com" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/[0.08] px-6 md:px-12 lg:px-16 pt-20 pb-10" data-testid="footer">
      <div className="flex flex-col gap-16 md:flex-row md:justify-between">
        <div>
          <Logo size="text-4xl md:text-6xl" showStudios />
          <p className="mt-8 max-w-xs text-sm font-light text-white/45">
            Content systems engineered for attention, retention and conversion.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-12 sm:grid-cols-3">
          <div className="flex flex-col gap-4">
            <span className="label text-white/35">MENU</span>
            {NAV.map((n) => (
              <a key={n.label} href={n.href} className="label text-white/70 hover:text-lav-400 transition-colors">
                {n.label}
              </a>
            ))}
          </div>
          <div className="flex flex-col gap-4">
            <span className="label text-white/35">SOCIAL</span>
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noreferrer" data-cursor="OPEN" className="label text-white/70 hover:text-lav-400 transition-colors">
                {s.label}
              </a>
            ))}
          </div>
          <div className="flex flex-col gap-4">
            <span className="label text-white/35">CONTACT</span>
            <a href="mailto:info@21studios.club" data-cursor="OPEN" className="label text-white/70 hover:text-lav-400 transition-colors">
              INFO@21STUDIOS.CLUB
            </a>
            <a href={CALENDLY} target="_blank" rel="noreferrer" data-cursor="OPEN" className="label text-lav-400">
              BOOK A CALL ↗
            </a>
          </div>
        </div>
      </div>

      <div className="mt-20 flex flex-col gap-4 border-t border-white/[0.06] pt-8 md:flex-row md:justify-between">
        <span className="label text-white/30">© {new Date().getFullYear()} TWENTYONE STUDIOS</span>
        <span className="label text-white/30">BUILT TO MOVE</span>
      </div>
    </footer>
  );
}
